/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from "react";

import getText from "Translator";

import jMoment from "moment-jalaali";

import moment from "moment-jalaali";
import {
  setFileVisible,
  storeFilesSugesstoin,
  shareFile,
} from "controllers/FileController";
import Swal from "sweetalert2";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ForumIcon from "@mui/icons-material/Forum";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";
import { setNotification } from "context";
import { setAction } from "context";
import { setTitle } from "context";
import { setHeader } from "context";
import { getUnreadedNotifications } from "controllers/NotificationController";
import { calculatePageItemsFromServer } from "controllers/PageController";
import { getHelpPageFromServer } from "controllers/PageController";
import { getBackPageFromServer } from "controllers/PageController";
import { getNextPageFromServer } from "controllers/PageController";
import { getResultPageFromServer } from "controllers/PageController";
import { getSelectedCommentsWithFileid } from "controllers/ForumController";
import { convertToEnglishNumber } from "controllers/controller";
import { insertCopyList } from "controllers/PageController";
import {
  Avatar,
  Button,
  Card,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import NoteComponent from "./components/NoteComponent";
import TextComponent from "./components/TextComponent";
import CalcComponent from "./components/CalcComponent";
import NumberComponent from "./components/NumberComponent";
import FlatComponent from "./components/FlatDComponent";
import RangeComponent from "./components/RangeComponent";
import DBComponent from "./components/DBComponent";
import MDBComponent from "./components/MDBComponent";
import FileAttachComponent from "./components/FileAttachComponent";
import SendToComponent from "./components/SendToComponent";
import SwitchComponent from "./components/SwitchComponent";
import SelectDateComponent from "./components/SelectDateComponent";
import ListComponent from "./components/ListComponent";
import NewPatientComponent from "views/fileScreen/components/NewPatientComponent";
import SendToColleagueComponent from "./components/SendToColleagueComponent";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { catchMessage, errorMessage } from "components/AlertComponent";
import SelectComponent from "./components/SelectComponent";
import DateComponent from "./components/DateComponent";
import { setLoading } from "context";
import ShareComponent from "./components/ShareComponent";
import { insertHistory } from "controllers/PageController";
import { deleteHistory } from "controllers/PageController";

let headerValue = "";
let fileInfo;
let page;
let emptyData = {
  selectedItemType: "",
  displayLimitedchb: false,
  sendMode: "",
  selectedItem: {},
  selectedItemAnswersSearch: "",
  modalVisible: false,
  capsuleTitleVisible: false,
  clinicTitle: "",
  questionslist: [{ resultText: "" }],
  btnBackVisible: true,
  pageTitle: "",
  pagemode: 1,
  showMandatoryError: false,
  nationalCode: "",
  birthYear: "",
  patientName: "",
  patientFamily: "",
  patientFullName: "",
  patientExist: true,
  myQuestion: "",
  limitedSending: false,
};
let sleepTime = 400;
let autoFocus;
export default function PageView(props) {
  const [controller, dispatch] = useMaterialUIController();
  const [questionList, setQuestionList] = useState([]);
  const [details, setDetails] = useState(emptyData);
  const [backAction, setBackAction] = useState(false);
  const [isHelpPage, setIsHelpPage] = useState(false);
  const [open, setOpen] = useState(false);
  const [resultText, setResultText] = useState("");
  const [resultTextBot, setResultTextBot] = useState("");
  const [commentsText, setCommentsText] = useState("");
  const [mySuggestion, setMySuggestion] = useState("");
  const [moreFindings, setMoreFindings] = useState("");
  const [textChange, setTextChange] = useState("");
  //const [autoFocus, setAutoFocus] = useState();

  const [reload, setReload] = useState(new Date());
  const [mode, setMode] = useState("newquestion");
  const [allowInit, setAllowInit] = useState(true);
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const myRef = useRef(null);
  const navigate = useNavigate();

  const setNotificationCount = async () => {
    try {
      if (controller.authenticated) {
        let result = await getUnreadedNotifications(controller);
        if (result.success) {
          if (result.data !== controller.notification) {
            setNotification(dispatch, result.data);
          }
        } else {
        }
      }
    } catch (err) {}
  };
  const doCopy = async (item) => {
    try {
      if (item.type == "MRD" || item.type == "DB") {
        let hasSame = false;
        if (item.useranswer.length == item.copyValue.length) {
          hasSame = true;
          item.useranswer.map((ii) => {
            if (item.copyValue.filter((a) => a + "" == ii + "").length == 0) {
              hasSame = false;
            }
          });
        }
        if (hasSame) {
          await Promise.all(
            item.useranswer.map(async (ii) => {
              await editQuestionValueHandle(item, ii);
            })
          );
        } else {
          await Promise.all(
            item.useranswer.map(async (ii) => {
              await editQuestionValueHandle(item, ii);
            })
          );
          await Promise.all(
            item.copyValue.map(async (ii) => {
              await editQuestionValueHandle(item, ii);
            })
          );
        }
      } else {
        if (item.useranswer == item.copyValue) {
          editQuestionValueHandle(item, "");
        } else {
          editQuestionValueHandle(item, item.copyValue);
        }
      }
    } catch (err) {
      setLoading(dispatch, false);
      catchMessage(err, "fa");
    }
  };
  const copyLastDatas = async (auto) => {
    try {
      if (questionList) {
        questionList.map(async (item) => {
          if (item.copyValue) {
            if (auto === true) {
              if (item.useranswer + "" == "") {
                await doCopy(item);
              }
            } else {
              await doCopy(item);
            }
          }
        });
      }
    } catch (err) {
      setLoading(dispatch, false);
      console.log(err);
    }
  };

  const insertHistoryHandler = async (questionParam, answer) => {
    try {
      const newData = {
        question: questionParam.id,
        answer,
        nationalCode: fileInfo.nationalCode,
        file: fileInfo.file,
      };

      setLoading(dispatch, true);
      let result = await insertHistory(newData, controller);
      setLoading(dispatch, false);

      if (result.success) {
        questionParam.history = result.history;
        return true;
      } else {
        errorMessage(result.message, result.code);
        return false;
      }
    } catch (err) {
      setLoading(dispatch, false);
      catchMessage(err, "fa");
    }
  };
  useEffect(() => {
    if (headerValue.includes("allowcopy")) {
      copyLastDatas(true);
    }
  }, [questionList]);
  useEffect(() => {
    (async () => {
      if (!fileInfo) {
      }

      if (controller.action) {
        if (controller.action.startsWith("nextpage")) {
          setNotificationCount();
          setLoading(dispatch, true);
          if (resultText.length > 0) {
            setLoading(dispatch, false);
            return;
          }
          nextPage("next");
        } else if (controller.action.startsWith("pageslist")) {
          setMode("pageslist");
          setOpen(true);
          setLoading(dispatch, false);
          return;
        } else if (controller.action.startsWith("filelist")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          goBackToFileList();
          setLoading(dispatch, false);
          return;
        } else if (controller.action.startsWith("fileattach")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          setMode("fileattach");
          setOpen(true);
          setLoading(dispatch, false);
          return;
        } else if (controller.action.startsWith("backpage")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          backPage();
          setMode("");
        } else if (controller.action.startsWith("backfirstpage")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            await filesSugesstoinHandler(false);
          }
          let menu = await localStorage.getItem("$menu");
          menu = JSON.parse(menu);
          menu.showResultOfFile = false;
          menu.visitedpageslist = [];
          menu.resultText = "";
          menu.resultTextBot = "";
          await localStorage.setItem("$menu", JSON.stringify(menu));

          window.location.replace("/pageview");
        } else if (controller.action.startsWith("resultpagemenu")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          setMode("resultmenu");
          setOpen(true);
        } else if (controller.action.startsWith("share")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          shareHandlre();
        } else if (controller.action.startsWith("allowcopy")) {
          copyLastDatas(false);
        } else if (controller.action.startsWith("commentmenu")) {
          if (resultText.length > 0 || resultTextBot.length > 0) {
            filesSugesstoinHandler(false);
          }
          let menu = await localStorage.getItem("$menu");
          menu = JSON.parse(menu);
          menu.openFrom = "file";
          await localStorage.setItem("$menu", JSON.stringify(menu));

          navigate("/chatroom");
        }
        setAction(dispatch, "");
      } else {
        if (!backAction) {
        }
      }
      window.scrollTo(0, 0);
      // if (myRef.current !== null) {
      //   console.log("myRefmyRef");
      //   myRef.current.scrollIntoView();
      // }
    })();
  }, [controller.action]);
  useEffect(() => {
    details.mainPageState = "main";
    setLoading(dispatch, true);
    nextPage("start");
    return () => {
      setAction(dispatch, "");
      setTitle(dispatch, { title: "", subtitle: "" });
      setNotificationCount();
    };
  }, []);
  const goBackToFileList = async () => {
    setMode("");
    fileInfo.file = "";
    fileInfo.resultText = "";
    fileInfo.resultTextBot = "";
    fileInfo.visitedpageslist = [];
    await localStorage.setItem("$menu", JSON.stringify(fileInfo));
    setAction(dispatch, "");
    navigate(-1);
  };
  const handleClose = () => {
    console.log("handleClosehandleClose");

    setOpen(false);
  };
  const filesSugesstoinHandler = async (showAlert = true) => {
    try {
      setTextChange("");
      let newData = {
        file: fileInfo.file,
        myQuestion: mySuggestion,
        moreFindings: moreFindings,
      };
      let result = await storeFilesSugesstoin(newData, controller);

      if (showAlert) {
        if (result.success) {
          Swal.fire({
            text: getText("alertsuccess", "fa"),
            position: "bottom-end",
            background: "#03fca1",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            text: getText("warningalert", "fa"),
            position: "bottom-end",
            background: "#f1b3af",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const calculatePageItems = async () => {
    try {
      let datas = {
        questions: questionList,
        file: fileInfo.file,
        page: fileInfo.visitedpageslist.filter((a) => a.current == true)[0]
          .page,
        nationalCode: fileInfo.nationalCode,
      };
      //
      setLoading(dispatch, true);
      //
      let result = await calculatePageItemsFromServer(datas, controller);

      setLoading(dispatch, false);
      if (result.success) {
        setQuestionList([]);
        setQuestionList(
          result.questions.sort((a, b) => a.rownumber - b.rownumber)
        );
        //console.log(result.questions);
      }
      setLoading(dispatch, false);
    } catch (err) {
      console.log(err);
    }
  };
  //ok
  const getFileInfo = async () => {
    try {
      fileInfo = await localStorage.getItem("$menu");
      if (fileInfo) {
        fileInfo = JSON.parse(fileInfo);
      }
    } catch (err) {}
  };
  const clearForm = () => {};
  const helpPage = async (page) => {
    try {
      setBackAction(true);
      setIsHelpPage(true);
      if (!fileInfo) {
        await getFileInfo();
      }
      setLoading(dispatch, true);
      let newData = {
        fileInfo,
        page,
        questions: questionList,
      };

      let result = await getHelpPageFromServer(newData, controller);
      //console.log(result);
      setLoading(dispatch, false);
      if (result.success) {
        setHeader(dispatch, "nextpage-filelist");

        fileInfo.pageTitle = result.pageTitle;

        fileInfo.btnBackVisible = false;
        fileInfo.formType = 3;
        fileInfo.visitedpageslist = result.visitedpageslist;

        await localStorage.setItem("$menu", JSON.stringify(fileInfo));
        setTitle(dispatch, {
          title: result.pageTitle,
          subtitle: fileInfo.capsuleText,
        });
        setQuestionList([]);
        setQuestionList(
          result.questions.sort((a, b) => a.rownumber - b.rownumber)
        );
      }
      setLoading(dispatch, false);
      setAction(dispatch, "");
    } catch (err) {
      console.log(err);
    }
  };
  const initComponent = async (questions) => {
    try {
      await clearForm();

      let allowcopyIcon = false;
      await getFileInfo();
      setBackAction(false);
      let savedq = await localStorage.getItem("$savedq");

      if (savedq) {
        savedq = JSON.parse(savedq);

        questions.map((item) => {
          let v = savedq.filter((a) => a.id + "" == item.id + "");
          if (v.length > 0) {
            if (item.type === "DB" || item.type === "MRD") {
              item.copyValue = [];
              v.map((x) => {
                item.copyValue.push(x.value);
              });
            } else {
              item.copyValue = v[0].value;
            }
          }
        });
      }
      let currentPage = fileInfo.visitedpageslist.filter(
        (a) => a.current === true
      );
      page = currentPage.page;
      currentPage = currentPage[0];
      if (fileInfo.headline === "scores") {
        setHeader(dispatch, "backpage-resultpagemenu-pageslist");
      } else if (fileInfo.headline === "diseases") {
        let isLastPage = false;
        fileInfo.visitedpageslist.map((item, index) => {
          if (
            item.current === true &&
            index + 1 === fileInfo.visitedpageslist.length
          ) {
            isLastPage = true;
          }
        });
        if (isLastPage === true) {
          setHeader(dispatch, "backpage-pageslist");
        } else {
          let allowcopyIcon = false;
          questions.map((item) => {
            if (item.allowCopy == true && item.copyValue) {
              allowcopyIcon = true;
            }
          });
          headerValue = "backpage-nextpage-pageslist";
          if (allowcopyIcon) {
            headerValue = headerValue + "-allowcopy";
          }
          setHeader(dispatch, "allowcopyIcon");
        }
      } else {
        questions.map((item) => {
          if (item.allowCopy == true && item.copyValue) {
            allowcopyIcon = true;
          }
          if (item.clearOnLoad && item.clearOnLoad) {
            item.useranswer = null;
          }
          if (item.type == "FLAT") {
            if (!item.useranswer) {
              let defaultAnswer = item.answers.filter(
                (a) => a.defaultValue == true
              );
              if (defaultAnswer && defaultAnswer.length > 0) {
                item.useranswer = defaultAnswer[0].id;
              }
            }
          }
        });
        headerValue = "nextpage-backpage-pageslist";

        if (fileInfo.from === "menu") {
          headerValue = headerValue + "-filelist";
          if (allowcopyIcon) {
            headerValue = headerValue + "-allowcopy";
          }
          setHeader(
            dispatch,
            currentPage.type === 3 ? "nextpage-filelist" : headerValue
          );
        } else {
          if (allowcopyIcon) {
            headerValue = headerValue + "-allowcopy";
          }
          setHeader(
            dispatch,
            currentPage.type === 3 ? "nextpage" : headerValue
          );
        }
      }
      setTitle(dispatch, {
        title: currentPage.title,
        subtitle: fileInfo.capsuleText,
      });
      //  console.log(questions);
      setQuestionList([]);
      setQuestionList(questions.sort((a, b) => a.rownumber - b.rownumber));
      setLoading(dispatch, false);
    } catch (err) {
      setLoading(dispatch, false);
      console.log(err);
    }
  };

  const backPage = async () => {
    try {
      if (!fileInfo) {
        await getFileInfo();
      }

      if (
        fileInfo.showResultOfFile ||
        fileInfo.resultText !== "" ||
        fileInfo.resultTextBot !== ""
      ) {
        goBackToFileList();
        setLoading(dispatch, false);
        return;
      }

      setHeader(dispatch, "nextpage-backpage-filelist-pageslist");

      if (fileInfo.limitedFile) {
        fileInfo.file = "";
        if (fileInfo.headline.toLowerCase() === "complaints") {
        }
        setAction(dispatch, "");

        navigate(-1);
        setLoading(dispatch, false);
        return;
      }
      // console.log(fileInfo.visitedpageslist);
      let currentPageIndex = 0;
      fileInfo.visitedpageslist.map((item, index) => {
        if (item.current === true) {
          currentPageIndex = index;
        }
      });

      if (
        currentPageIndex === 0 ||
        (fileInfo.visitedpageslist.length === 1 && fileInfo.from === "file")
      ) {
        fileInfo.file = "";
        setAction(dispatch, "");
        setTitle(dispatch, { title: "", subtitle: "" });

        navigate(-1);
        setLoading(dispatch, false);
        return;
      }
      if (
        fileInfo.mainPageState === "main" &&
        fileInfo.helppagestate !== "help" &&
        fileInfo.visitedpageslist.length === 1
      ) {
        goBackToFileList();
        setLoading(dispatch, false);
        return;
      }
      if (!questionList) {
        fileInfo.formType = 4;
      } else {
        fileInfo.formType = 0;
      }
      setLoading(dispatch, true);
      let result = await getBackPageFromServer(fileInfo, controller);
      setLoading(dispatch, false);
      if (result.success) {
        if (result.visitedpageslist.length === 0) {
          setAction(dispatch, "");
          navigate(-1);
          setLoading(dispatch, false);
          return;
        }
        setCommentsText("");
        setResultText("");
        setResultTextBot("");
        setMySuggestion("");
        let currentPage = result.visitedpageslist.filter(
          (a) => a.current === true
        );
        page = currentPage[0].page;
        fileInfo.resultText = "";
        fileInfo.resultTextBot = "";
        fileInfo.formType = currentPage[0].formType;
        fileInfo.visitedpageslist = result.visitedpageslist;
        await localStorage.setItem("$menu", JSON.stringify(fileInfo));

        await initComponent(result.questions);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const validationForNext = () => {
    try {
      let mandatoryCount = 0;
      let qtitle = "";
      let errortext = "";
      let tempQuestion = questionList;
      tempQuestion.map((ql, index) => {
        qtitle = ql.text;
        if (ql.type === "RANGE" && !ql.mandatory && ql.useranswer !== "") {
          let minValue = ql.answers[0].answer;
          let maxValue = ql.answers[1].answer;

          console.log(
            "ql.useranswerql.useranswerql.useranswer",
            minValue,
            maxValue,
            ql.useranswer
          );
          if (
            (parseFloat(ql.useranswer) >= parseFloat(minValue) &&
              parseFloat(ql.useranswer) <= parseFloat(maxValue)) === false
          ) {
            ql.error = true;
            mandatoryCount += 1;
            errortext +=
              mandatoryCount +
              " - " +
              qtitle +
              " : " +
              getText("answernotinrange", "fa") +
              "<br />";
          }
        }

        if (ql.mandatory && !ql.useranswer && ql.type !== "LINK") {
          ql.error = true;
          mandatoryCount += 1;
          errortext +=
            mandatoryCount +
            " - " +
            qtitle +
            " : " +
            getText("errormandatory", "fa") +
            "<br />";
        } else if (!ql.error) {
          ql.error = false;
        }
      });
      if (mandatoryCount > 0) {
        Swal.fire({
          title:
            getText("warning", "fa") +
            " : " +
            mandatoryCount +
            getText("errors", "fa"),
          html: errortext,
          confirmButtonText: getText("ok", "fa"),
        });

        setBackAction(true);
        setQuestionList(tempQuestion);

        setReload(new Date());
        return false;
      } else {
        return true;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };
  //ok
  const storeAllowCopy = async () => {
    try {
      let savedq = await localStorage.getItem("$savedq");
      let chageAllowCopy = false;
      let convertToJson = false;
      questionList.map((item, index) => {
        if (item.allowCopy && item.useranswer.length > 0) {
          if ((savedq + "").length < 10) {
            convertToJson = true;
            savedq = [];
          } else {
            if (convertToJson == false) {
              convertToJson = true;
              savedq = JSON.parse(savedq);
            }
          }
          savedq = savedq.filter((a) => a.id + "" !== item.id + "");
          let usa = item.useranswer;
          if (item.type === "DB" || item.type === "MRD") {
            item.useranswer.map((mitem) => {
              savedq.push({
                id: item.id,
                value: mitem,
              });
            });
          } else {
            savedq.push({
              id: item.id,
              value: usa,
            });
          }
          chageAllowCopy = true;
        }
      });
      if (chageAllowCopy) {
        localStorage.setItem("$savedq", JSON.stringify(savedq));
      }
    } catch (err) {}
  };
  const nextPage = async (mode, pageId) => {
    try {
      await getFileInfo();
      console.log("getFileInfo", mode);
      if (mode !== "menu") {
        console.log("menumenumenumenumenumenu");
        let continiue = await validationForNext();
        if (!continiue) {
          setLoading(dispatch, false);
          return;
        }
      }

      if (fileInfo.visitedpageslist.length > 0 && mode === "start") {
        let currentPageIndex = 0;
        let currentPage;
        fileInfo.visitedpageslist.map((item, index) => {
          if (item.current === true) {
            currentPageIndex = index;
            currentPage = item;
          }
        });
        if (currentPageIndex === 0) {
          fileInfo.visitedpageslist = [];
          await localStorage.setItem("$menu", JSON.stringify(fileInfo));
        } else {
          let vpi = fileInfo.visitedpageslist;
          vpi[currentPageIndex - 1].current = true;
          vpi[currentPageIndex].current = false;
          fileInfo.visitedpageslist = vpi;
          await localStorage.setItem("$menu", JSON.stringify(fileInfo));
        }
      }

      if (fileInfo.visitedpageslist.length > 0 && mode === "menu") {
        let vpi = fileInfo.visitedpageslist;
        vpi.map((ppp) => {
          if (ppp.page === pageId) {
            ppp.current = true;
          } else {
            ppp.current = false;
          }
        });
        let newvpi = [];
        console.log("allowpages", fileInfo.allowpages);
        if (fileInfo.allowpages) {
          vpi.map((ppp) => {
            console.log(fileInfo.allowpages, ppp);
            newvpi.push(ppp);
          });
        } else {
          newvpi = vpi;
        }
        fileInfo.visitedpageslist = newvpi;
        await localStorage.setItem("$menu", JSON.stringify(fileInfo));
      }

      setLoading(dispatch, true);

      let datas = {
        questions: questionList,
        fileInfo: fileInfo,
        mode,
      };
      let result = await getNextPageFromServer(datas, controller);
      console.log("resultresult", controller, result);
      setLoading(dispatch, false);

      if (result.success) {
        let newvpi = result.visitedpageslist;
        if (mode == "start") {
          newvpi = [];
          let setcurrent = 0;
          let setcurrentState = false;
          console.log(
            "fileInfo.allowpages)fileInfo.allowpages)",
            fileInfo.allowpages,
            controller.userRole
          );
          if (fileInfo.allowpages && controller.userRole == "filler") {
            result.visitedpageslist.map((ppp, index) => {
              if (fileInfo.allowpages.includes(ppp.page)) {
                if (!setcurrentState) {
                  setcurrentState = true;
                  console.log(index);
                  ppp.current = true;
                  setcurrent = index;
                }
                newvpi.push(ppp);
              }
            });
          } else {
            newvpi = result.visitedpageslist;
          }
          fileInfo.visitedpageslist = newvpi;
          if (setcurrent !== 0) {
            console.log("setcurrent !== 0");
            datas = {
              questions: questionList,
              fileInfo: fileInfo,
              mode,
            };
            result = await getNextPageFromServer(datas, controller);
          }
        }
        if (result.message === "resultText") {
          goBackToFileList();
          return;
        }
        fileInfo.resultText = "";
        fileInfo.resultTextBot = "";

        let currentPage = newvpi.filter((a) => a.current === true);
        page = currentPage[0].page;

        console.log(page, result);
        setLoading(dispatch, false);
        await localStorage.setItem("$menu", JSON.stringify(fileInfo));

        await initComponent(result.questions);
      }
      setLoading(dispatch, false);
      setAction(dispatch, "");
    } catch (err) {
      console.log(err);
      setLoading(dispatch, false);
      catchMessage(err, "fa");
    }
  };
  const setFocuse = (code) => {
    // autoFocus = code;
    //setAutoFocus(code);
  };
  let lastValue = "";
  const editQuestionValueHandle = async (question, newValue, saveToServer) => {
    try {
      if (question.copyList) {
        if (question.copyList.length > 0) {
          if (
            question.copyList.filter((a) => a + "" == newValue + "").length !==
            0
          ) {
            let lastFiles = await localStorage.getItem("$lastfile");

            if (lastFiles == null) {
              let newFileList = [
                {
                  capsule: fileInfo.capsule,
                  answer: newValue,
                  lastnationalCode: fileInfo.nationalCode,
                  lastFile: fileInfo.file,
                },
              ];
              await localStorage.setItem(
                "$lastfile",
                JSON.stringify(newFileList)
              );
            } else {
              let newFileList = JSON.parse(lastFiles);
              let capsuleLastFile = newFileList.filter(
                (a) =>
                  a.answer + "" == newValue + "" &&
                  a.capsule + "" == fileInfo.capsule + ""
              );

              if (capsuleLastFile.length == 0) {
                let newFile = {
                  capsule: fileInfo.capsule,
                  answer: newValue,
                  lastnationalCode: fileInfo.nationalCode,
                  lastFile: fileInfo.file,
                };
                newFileList.push(newFile);
                await localStorage.setItem(
                  "$lastfile",
                  JSON.stringify(newFileList)
                );
              } else {
                if (
                  capsuleLastFile[0].lastnationalCode + "" !==
                  fileInfo.file + ""
                ) {
                  let page = null;
                  if (fileInfo.visitedpageslist.length > 0) {
                    let cp = fileInfo.visitedpageslist.filter(
                      (a) => a.current == true
                    );
                    if (cp.length > 0) {
                      page = cp[0].page;
                    }
                  }
                  let dadas = {
                    pageQuestion: question.pageQuestion,
                    answer: newValue,
                    file: fileInfo.file,
                    nationalCode: fileInfo.nationalCode,
                    lastFile: capsuleLastFile[0].lastFile,
                    capsule: fileInfo.capsule,
                    lastnationalCode: capsuleLastFile[0].lastnationalCode,
                  };
                  let copyListResult = await insertCopyList(dadas, controller);
                  if (copyListResult.success) {
                    let qtemp = [];
                    questionList.map((qitem) => {
                      if (question.id + "" == qitem.id + "") {
                      }
                      if (question.id + "" !== qitem.id + "") {
                        let selected = copyListResult.data.filter(
                          (a) => a.question + "" == qitem.id + ""
                        );
                        if (selected.length !== 0) {
                          qitem.useranswer = selected[0].answer;
                        }
                        qtemp.push(qitem);
                      }
                    });
                    if (
                      qtemp.length > 0 &&
                      qtemp.length == questionList.length - 1
                    ) {
                      setQuestionList(qtemp);
                      setReload(new Date());
                    }

                    let temp = [];
                    newFileList.map((item) => {
                      if (
                        !(
                          item.answer + "" == newValue + "" &&
                          item.capsule + "" == fileInfo.capsule + ""
                        )
                      ) {
                        temp.push(item);
                      }
                    });
                    let newFile = {
                      capsule: fileInfo.capsule,
                      answer: newValue,
                      lastnationalCode: fileInfo.nationalCode,
                      lastFile: fileInfo.file,
                    };
                    temp.push(newFile);

                    await localStorage.setItem(
                      "$lastfile",
                      JSON.stringify(temp)
                    );
                  }
                }
              }
            }
          }
        }
      }
      let currentQuestion = questionList.filter(
        (a) => a.id + "" === question.id + ""
      );
      lastValue = currentQuestion[0].useranswer;
      if (question.type === "DB" || question.type === "MRD") {
        let existanswer = currentQuestion[0].useranswer.filter(
          (a) => a + "" === newValue + ""
        );
        if (existanswer.length === 0) {
          currentQuestion[0].useranswer.push(newValue);
        } else {
          currentQuestion[0].useranswer = currentQuestion[0].useranswer.filter(
            (a) => a + "" !== newValue + ""
          );
        }
      } else if (question.type === "FLATB") {
        //console.log("FLATB", newValue, question.multiMode, toBack);
        if (newValue) {
          if (question.multiMode) {
            currentQuestion[0].useranswer = newValue;
          } else {
            currentQuestion[0].useranswer = newValue;
          }
        } else {
          currentQuestion[0].useranswer = [];
        }
      } else {
        currentQuestion[0].useranswer = newValue;
      }

      if (question.type === "SELECT" || question.type === "DBS") {
        let answerText = question.answers.filter(
          (a) => a.id + "" === newValue + ""
        );
        if (answerText.length > 0) {
          currentQuestion[0].useranswerText = answerText[0].answer;
        } else {
          currentQuestion[0].useranswerText = undefined;
        }
      }
      if (question.type === "DATE") {
        currentQuestion[0].useranswer = newValue;
        if (newValue) {
          currentQuestion[0].useranswerText =
            controller.dateMode === "en"
              ? convertToEnglishNumber(moment(newValue).format("YYYY/DD/MM"))
              : convertToEnglishNumber(
                  jMoment(newValue).format("jYYYY/jMM/jDD")
                );
        } else {
          currentQuestion[0].useranswerText = "";
        }
      }
      setQuestionList([]);
      setQuestionList(questionList.sort((a, b) => a.rownumber - b.rownumber));
      let calcQuestiosx = questionList.filter(
        (a) => a.type === "CALC" || a.visibleCondition
      );

      //your code to be executed after 1 second

      if (calcQuestiosx.length > 0 || saveToServer) {
        let gotocalc = false;
        calcQuestiosx.map((item) => {
          if (item.calcCodes && item.calcCodes.indexOf(question.code) >= 0) {
            gotocalc = true;
          }
          // console.log(
          //   question.code,
          //   gotocalc,
          //   item.calcCodes,
          //   item.calcCodes.indexOf(question.code)
          // );
        });
        if (gotocalc == true || saveToServer) {
          calculatePageItems();
        }
      }

      setReload(new Date());
    } catch (err) {
      console.log(err);
    }
  };
  const shareHandlre = async () => {
    let datas = {
      capsule: fileInfo.capsule,
      forumGroup: fileInfo.capsule,
      file: fileInfo.file,
    };
    setLoading(dispatch, true);
    let result = await shareFile(datas, controller);
    setLoading(dispatch, false);
    if (result.success) {
      setMode("shared");
      setOpen(true);
    } else {
      Swal.fire({
        title: getText("warning", "fa"),
        text: result.message,
        confirmButtonText: getText("ok", "fa"),
      });
    }
  };

  const sendToForumHandler = async () => {
    if (fileInfo.nationalCode.length < 10) {
      Swal.fire({
        title: getText("warning", "fa"),
        text: getText("savethefilefirst", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
      setMode("save");
      setLoading(dispatch, false);
      return;
    }
    setOpen(false);
    setMode("sendToForum");
    setOpen(true);
  };
  const sendToCollegueHandler = async () => {
    if (fileInfo.nationalCode.length < 10) {
      Swal.fire({
        title: getText("warning", "fa"),
        text: getText("savethefilefirst", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
      setMode("save");
      setLoading(dispatch, false);
      return;
    }
    setMode("sendToCollegue");
    setOpen(true);
  };
  const openSelectList = (item) => {
    setSelectedQuestion(item);
    setMode("select");
    setOpen(true);
  };
  const openSelectDate = (item) => {
    setSelectedQuestion(item);
    setMode("date");
    setOpen(true);
  };
  const createPage = () => {
    return (
      <Grid container>
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          style={{ paddingBottom: 10, paddingLeft: 10, paddingRight: 10 }}
        >
          <Card
            style={{
              with: "100%",
            }}
          >
            <List className="root" style={{ paddingLeft: 0, paddingRight: 0 }}>
              {fileInfo &&
                fileInfo.visitedpageslist &&
                fileInfo.visitedpageslist.map((item) => (
                  <ListItem
                    selected={
                      item.page ==
                      fileInfo.visitedpageslist.filter(
                        (a) => a.current == true
                      )[0].page
                    }
                    button
                    onClick={() => {
                      nextPage("menu", item.page);
                    }}
                  >
                    <ListItemText
                      primary={item.title} //invite to cooperate
                    />
                  </ListItem>
                ))}
            </List>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          style={{ marginBottm: 100, paddingLeft: 10, paddingRight: 10 }}
        >
          <Card
            style={{
              with: "100%",
              padding: 25,
            }}
          >
            <Grid container>
              {questionList &&
                questionList.map((item, index) => {
                  switch (item.type) {
                    case "LINK": {
                      return (
                        <div
                          style={{
                            fontWeight: "300",
                            fontSize: 16,
                            marginTop: 10,
                            paddingRight: 25,
                            paddingLeft: 25,
                            width: "100%",
                            textAlign: "justify",
                          }}
                          dangerouslySetInnerHTML={{ __html: item.text }}
                        ></div>
                      );
                    }
                    case "MEMO": {
                      return (
                        <NoteComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "TEXT": {
                      return (
                        <TextComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "CALC": {
                      return (
                        <CalcComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          editQuestionHandle={editQuestionValueHandle}
                          setSelectedQuestion={setSelectedQuestion}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "DATE": {
                      return (
                        <DateComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          editQuestionHandle={editQuestionValueHandle}
                          fileInfo={fileInfo}
                          openSelectDate={openSelectDate}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "INT": {
                      return (
                        <NumberComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          autoFocus={autoFocus == item.code ? true : false}
                          setFocuse={setFocuse}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          insertHistoryHandler={insertHistoryHandler}
                        />
                      );
                    }
                    case "FLAT":
                    case "FLATB": {
                      return (
                        <FlatComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "SELECT":
                    case "DBS": {
                      return (
                        <>
                          <SelectComponent
                            question={item}
                            itemsCount={questionList.length}
                            index={index}
                            key={item.id}
                            helpPage={helpPage}
                            fileInfo={fileInfo}
                            editQuestionHandle={editQuestionValueHandle}
                            openSelectList={openSelectList}
                            setFocuse={setFocuse}
                          />
                        </>
                      );
                    }
                    case "RANGE": {
                      return (
                        <RangeComponent
                          disabled={
                            (item.code + "" === "1183" &&
                              fileInfo.nationalCode !== "") ||
                            fileInfo.limitedFile == true
                              ? true
                              : false
                          }
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          error={item.error}
                          helpPage={helpPage}
                          editQuestionHandle={editQuestionValueHandle}
                          autoFocus={autoFocus == item.code ? true : false}
                          setFocuse={setFocuse}
                          insertHistoryHandler={insertHistoryHandler}
                        />
                      );
                    }
                    case "TF": {
                      return (
                        <SwitchComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "CHECKED": {
                      return (
                        <DBComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                    case "MRD":
                    case "DB": {
                      return (
                        <MDBComponent
                          question={item}
                          itemsCount={questionList.length}
                          index={index}
                          key={item.id + "xx"}
                          helpPage={helpPage}
                          disabled={fileInfo.limitedFile}
                          editQuestionHandle={editQuestionValueHandle}
                          setFocuse={setFocuse}
                        />
                      );
                    }
                  }
                })}
              <div style={{ padding: 8, width: "100%", marginTop: 20 }}>
                {resultText.length > 0 && (
                  <div style={{ textAlign: "justify", fontWeight: "550" }}>
                    <div dangerouslySetInnerHTML={{ __html: resultText }} />
                    <br />
                  </div>
                )}

                {/* )} */}

                <Button
                  fullWidth
                  style={{
                    backgroundColor: "#039dfc",
                    borderColor: "#0063cc",
                    color: "#FFF",
                    "&:active": {
                      boxShadow: "none",
                      backgroundColor: "#0062cc",
                      borderColor: "#005cbf",
                    },
                    "&:focus": {
                      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
                    },
                  }}
                  variant="contained"
                  onClick={() => {
                    nextPage("next");
                  }}
                >
                  ثبت و ادامه
                </Button>
              </div>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("questions", "fa")} />
      {/* <div
        style={{ width: "100%", height: 1, backgroundColor: "red" }}
        ref={myRef}
      ></div> */}

      {fileInfo && createPage()}
      <div style={{ width: "100%", height: 105 }}></div>
      <Drawer anchor="bottom" open={open} onClose={handleClose}>
        <div className="drawertitle">
          <IconButton
            style={{
              color: "#FFF",
              height: 35,
              width: 35,
              top: 5,
              position: "absolute",
              right: 5,
            }}
            aria-label="HighlightOffOutlinedIcon"
            onClick={() => {
              setOpen(false);
            }}
          >
            <HighlightOffOutlinedIcon />
          </IconButton>
          {mode === "shared" && getText("sharefile", "fa")}
          {mode === "pageslist" && getText("pageslist", "fa")}
          {(mode === "select" || mode === "date") && selectedQuestion.text}
          {mode === "sendToForum" && getText("sendtoforum", "fa")}
          {mode === "sendToCollegue" && getText("sendtocollegue", "fa")}
        </div>
        <div className="drawertext">
          {mode === "shared" && <ShareComponent fileInfo={fileInfo} />}
          {mode === "pageslist" && (
            <div
              className={"fa" === "en" ? "listmenu" : "listmenu rtl"}
              style={{ padding: 15 }}
            >
              <List>
                {fileInfo.visitedpageslist.map((item) => (
                  <ListItem button onClick={() => {}}>
                    <ListItemText
                      style={{ color: "#039dfc" }}
                      primary={item.title}
                    />
                  </ListItem>
                ))}
              </List>
            </div>
          )}
          {mode === "resultmenu" && (
            <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
              <List>
                {fileInfo.nationalCode === "" && (
                  <ListItem
                    autoFocus
                    button
                    onClick={() => {
                      setMode("save");
                    }}
                  >
                    <SaveAsOutlinedIcon
                      style={{ color: "#039dfc", paddingRight: 5 }}
                    />
                    <ListItemText
                      style={{ color: "#039dfc" }}
                      primary={getText("save", "fa")}
                    />
                  </ListItem>
                )}
                {fileInfo.headline === "complaints" && (
                  <div>
                    <ListItem
                      autoFocus
                      button
                      onClick={() => {
                        sendToCollegueHandler();
                      }}
                    >
                      <PeopleAltIcon
                        style={{ color: "#039dfc", paddingRight: 5 }}
                      />
                      <ListItemText primary={getText("sendtocollegue", "fa")} />
                    </ListItem>
                    <ListItem
                      autoFocus
                      button
                      onClick={() => {
                        sendToForumHandler();
                      }}
                    >
                      <ForumIcon
                        style={{ color: "#039dfc", paddingRight: 5 }}
                      />
                      <ListItemText primary={getText("sendtoforum", "fa")} />
                    </ListItem>

                    <ListItem
                      autoFocus
                      button
                      onClick={() => {
                        Swal.fire({
                          title: getText("warning", "fa"),
                          text: getText("deleteconfirm", "fa"),
                          confirmButtonText: getText("yes", "fa"),
                          cancelButtonText: getText("no", "fa"),

                          showCancelButton: true,
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            let newData = {
                              file: fileInfo.file,
                              visible: false,
                              isMyFile: fileInfo.isMyFile,
                            };
                            let visibleResult = await setFileVisible(
                              newData,
                              controller.token
                            );
                            if (visibleResult.success) {
                              Swal.fire({
                                text: getText("alertsuccess", "fa"),
                                position: "bottom-end",
                                background: "#03fca1",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                              goBackToFileList();
                              setOpen(false);
                            } else {
                              Swal.fire({
                                text: getText("warningalert", "fa"),
                                position: "bottom-end",
                                background: "#f1b3af",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            }
                          } else {
                            setOpen(false);
                          }
                        });
                      }}
                    >
                      <DeleteOutlineIcon
                        style={{ color: "#039dfc", paddingRight: 5 }}
                      />
                      <ListItemText primary={getText("delete", "fa")} />
                    </ListItem>
                  </div>
                )}
              </List>
            </div>
          )}
          {mode === "save" && (
            <NewPatientComponent
              props={props}
              closeHandle={handleClose}
              from="save"
              file={fileInfo.file}
            />
          )}
          {mode === "sendToForum" && (
            <SendToComponent
              closeActionSheet={handleClose}
              fileInfo={fileInfo}
              resultText={resultText}
              resultTextBot={resultTextBot}
              myQuestion={mySuggestion}
              moreFindings={moreFindings}
            />
          )}
          {mode === "sendToCollegue" && (
            <SendToColleagueComponent
              closeActionSheet={handleClose}
              fileInfo={fileInfo}
            />
          )}
          {mode === "select" && (
            <ListComponent
              setFocuse={setFocuse}
              editQuestionValueHandle={editQuestionValueHandle}
              handleClose={handleClose}
              selectedQuestion={selectedQuestion}
              headline={fileInfo.headline}
              helpPage={helpPage}
            />
          )}
          {mode === "date" && (
            <SelectDateComponent
              setFocuse={setFocuse}
              editQuestionValueHandle={editQuestionValueHandle}
              handleClose={handleClose}
              selectedQuestion={selectedQuestion}
            />
          )}
          {mode === "fileattach" && (
            <FileAttachComponent
              from={fileInfo.limitedFile === true ? "other" : "page"}
              props={props}
              file={fileInfo.file}
              handleClose={handleClose}
            />
          )}
        </div>
      </Drawer>
      <Footer />
    </DashboardLayout>
  );
}
